import * as React from 'react'
import { NotificationLabelProps } from './typings'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const NotificationLabel: React.FC<NotificationLabelProps> = ({
  type,
  name,
  helperText,
  rightContent,
}) => {
  return (
    <>
      <Box display="flex" alignItems="center">
        <Box>
          <Typography variant="body2">{type} Notification</Typography>
          <Typography variant="subtitle3">{name}</Typography>
        </Box>

        {rightContent && <Box ml="auto">{rightContent}</Box>}
      </Box>
      <Typography variant="body1">{helperText}</Typography>
    </>
  )
}
NotificationLabel.displayName = 'NotificationLabel'
